import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  userDetails: null,
};

const userViewSlice = createSlice({
  name: "userView",
  initialState,
  reducers: {
    fetchUserDetails(state, action) {
      state.loading = true;
    },
    fetchUserDetailsSuccess(state, action) {
      state.userDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchUserDetailsFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = userViewSlice;
